import type { StaffCoordinationCustomerResponse as StaffCoordinationTicketResponse } from '@/types/apps/staff-coordination-customer.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export interface StaffCoordinationTicketServiceInterface {}

type StaffCoordinationTicketListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationTicketResponse>
>;

export class StaffCoordinationTicketService implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/staff-coordination/ticket',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationTicketListResponse> {
        return this.apiClient.fetchApi(this.endpoints.base(), params);
    }
}
